<template>
    <a-row type="flex" justify="center">
        <a-col :xs="24" :sm="24" :md="14" :lg="14">
            <a-button @click="$router.back()">Regresar</a-button>
            <a-card class="mt-1">
                <h1 class="mb-2">{{ announcement.title }}</h1>
                <div v-html="announcement.content"></div>
            </a-card>

            <div class="mt-2" style="padding-top: 20px;" v-if="announcement.file">
                <a target="_blank" rel="noreferrer" :href="announcement.file_url">Ver archivo adjunto</a>
            </div>
        </a-col>
    </a-row>
</template>

<script>

import { mapState, mapActions } from 'vuex'
export default {
    computed: {
        ...mapState({
            announcement: state => state.announcements.announcement
        })
    },
    methods: {
        ...mapActions({
            show: 'announcements/show'
        })
    },
    mounted() {
        this.show(this.$route.params.id)
    }
}
</script>

<style lang="scss" scoped>

</style>
